export default import.meta.ROLLUP_FILE_URL__92QDSx55b2KYOacJ301aw